import { Body16 } from "../../../text";

const Subtitle = Body16;

export default Subtitle;
